var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "li",
    {
      staticClass: "cw-pdf-toc-item",
    },
    [
      _c(
        "a",
        {
          attrs: {
            href: "#",
          },
          on: {
            click: function click($event) {
              $event.preventDefault()
              return _vm.tocPageNav(_vm.item.dest)
            },
          },
        },
        [
          _vm.item.bold
            ? _c("strong", [_vm._v(_vm._s(_vm.item.title))])
            : _c("span", [_vm._v(_vm._s(_vm.item.title))]),
        ]
      ),
      _vm._v(" "),
      _vm.item.items
        ? [
            _c(
              "ul",
              {
                staticClass: "cw-pdf-toc-sub-list",
              },
              _vm._l(_vm.item.items, function (item, index) {
                return _c("courseware-pdf-toc-item", {
                  key: index,
                  attrs: {
                    item: item,
                  },
                  on: {
                    tocPageNav: _vm.tocPageNav,
                  },
                })
              }),
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }